import { useSearchParams } from "routes/hooks";

export const ModalTypes = Object.freeze({
  CHANGE_PLAN: "changeplan",
});

function useModalLauncherFromSearchParam() {
  const [{ modal, ...modalParams }, setSearchParams] = useSearchParams();

  const closeModal = () => {
    return setSearchParams(modalParams);
  };

  const openModal = (modalType, params = {}) => {
    setSearchParams({ ...modalParams, ...params, modal: modalType });
  };

  return { modal, modalParams, openModal, closeModal };
}

export default useModalLauncherFromSearchParam;
